import { memo } from 'react';

import { toDate } from 'date-fns-tz';
import endOfQuarter from 'date-fns/endOfQuarter';
import formatReal from 'date-fns/format';
import isThisYear from 'date-fns/isThisYear';
import startOfQuarter from 'date-fns/startOfQuarter';

const SAME_YEAR_FORMAT = 'd MMM';
const DIFF_YEAR_FORMAT = 'd MMM yyyy';
const MONTH_ONLY_FORMAT = 'MMMM';
const MONTH_ONLY_FORMAT_SHORT = 'MMM';
const MONTH_ONLY_FORMAT_DIFF_YEAR = 'MMM yyyy';

const format = (date: Date, formatStr: string) => formatReal(date, formatStr, { weekStartsOn: 1 });

interface TargetDateProps {
	targetDate: string;
	targetDateType: string;
}

const NonMemoTargetDate = ({ targetDate, targetDateType }: TargetDateProps): string => {
	const date = toDate(targetDate);
	let displayedTargetDate = '';
	if (targetDateType === 'DAY') {
		displayedTargetDate = format(date, isThisYear(date) ? SAME_YEAR_FORMAT : DIFF_YEAR_FORMAT);
	} else if (targetDateType === 'MONTH') {
		displayedTargetDate = format(
			date,
			isThisYear(date) ? MONTH_ONLY_FORMAT : MONTH_ONLY_FORMAT_DIFF_YEAR,
		);
	} else if (targetDateType === 'QUARTER') {
		displayedTargetDate = `${format(startOfQuarter(date), MONTH_ONLY_FORMAT_SHORT)}-${format(
			endOfQuarter(date),
			isThisYear(date) ? MONTH_ONLY_FORMAT_SHORT : MONTH_ONLY_FORMAT_DIFF_YEAR,
		)}`;
	}

	return displayedTargetDate;
};

export const TargetDate = memo(NonMemoTargetDate);
